module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAASCAIAAAD9mVSFAAAACXBIWXMAAAsSAAALEgHS3X78AAAAoklEQVRoQ+3aoQ3DMBCF4Wt1wJL3yTxZw3tkH69xxBt4gIQVWEqlAqekqpT3f+jAgz8w8KOUYmZm5u7ruhpwL9u2pZTG/ZxPgTshdwghdwghdwghdwghdwghdwghdwghdwghdwghdwghdwghdwjx89r3vdY6mQ4552VZrlbAb/XeI+Jq9emdu7u31ibT4TgOcsffRcSXuZ+/f43HDKSQO4S8AJRjGx+N5NuYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/_front/front-RASM1000-120.png
// module id = rLzf
// module chunks = 0